import { createOptionalGenericContext } from '@luna/context';
import type { ReadonlySSEEventBus } from '@luna/api';

export const { createContextProvider: createSseContextProvider, useContext: useSseContext } =
    createOptionalGenericContext<{ eventBus?: ReadonlySSEEventBus }>('sse');
